/**
 * Created by Neil Benn on 22.08.2018.
 */
define('common/js/lib/util/getParameters',[],function() {
  return function getParameters(location) {
    return (location || window.location).search.slice(1).split('&').reduce(function (params, term) {
      var pair = term.split('=');
      params[pair[0]] = pair.length === 1 || decodeURIComponent(pair[1]);
      return params;
    }, {});
  };
});

